export type Locale = 'en' | 'es';

const LOCALE_TAG: Record<Locale, string> = {
  en: 'en-US',
  es: 'es-MX',
};

export function resolveLocaleTag(locale: string | undefined | null): string {
  if (!locale) return LOCALE_TAG.en;
  const short = locale.slice(0, 2).toLowerCase() as Locale;
  return LOCALE_TAG[short] ?? LOCALE_TAG.en;
}

export interface CurrencyFormatOptions {
  locale?: string;
  currency?: string;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
}

export function formatCurrency(amount: number, opts: CurrencyFormatOptions = {}): string {
  const { locale, currency = 'USD', minimumFractionDigits = 2, maximumFractionDigits = 2 } = opts;
  return new Intl.NumberFormat(resolveLocaleTag(locale), {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  }).format(amount);
}

export interface DateFormatOptions extends Intl.DateTimeFormatOptions {
  locale?: string;
}

export function formatDate(date: Date | string | number, opts: DateFormatOptions = {}): string {
  const { locale, ...rest } = opts;
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleDateString(resolveLocaleTag(locale), rest);
}

export function formatTime(date: Date | string | number, opts: DateFormatOptions = {}): string {
  const { locale, ...rest } = opts;
  const d = date instanceof Date ? date : new Date(date);
  return d.toLocaleTimeString(resolveLocaleTag(locale), rest);
}

export interface NumberFormatOptions extends Intl.NumberFormatOptions {
  locale?: string;
}

export function formatNumber(value: number, opts: NumberFormatOptions = {}): string {
  const { locale, ...rest } = opts;
  return new Intl.NumberFormat(resolveLocaleTag(locale), rest).format(value);
}
